<template lang="pug">
  bloco#galeria.-padding-desktop
    //- HEADER
    header(slot="header")
      titulo.-withbar.-upper Galeria
    //- CONTENT
    .conteudo(slot="content" v-if="!naoTemGalerias")
      listagem(:itens="albuns")
    //- FOOTER
    footer(slot="footer" v-if="!naoTemGalerias && perPage < totalGalerias")
      br
      hr.-normal
      paginacao(
      v-if="pagination",
        :gender='"o"',
        :object='"albuns"',
        :total='totalGalerias',
        :totalPage='totalPages',
        :perPage='perPage',
        :perPageAtual='albuns.length',
        :pageAtual="page")
    //- FEEDBACK
    template(slot="feedback" v-if="naoTemGalerias")
      br
      mensagem.-warn
        p Nenhum álbum foi encontrado no momento
</template>

<style lang="scss">
  #galeria {
    > .conteudo {
      > .albuns {
        margin: 30px 0;
        display: flex;
        flex-wrap: wrap;
        > .album {
          .data { position: relative; display: inline-block }
          .data:after {
            content: '';
            position: absolute;
            background-color: $color-blue-dark;
            top: 100%;
            right: 0;
            left: 0;
            height: 4px;
            width: 50%;
            border-radius: 7px;
          }
          > a {
            display: block;
            max-width: 150px;
            margin-bottom: 30px;
            &:hover {
              color: inherit;
              text-decoration: none;
            }
            > figure {
              > img {
                height: 130px;
                width: 150px;
                object-fit: cover;
                border-radius: 7px;
                margin-bottom: 7px;
              }
            }
          }
        }
      }
    }

    @include media(">=phone","<tablet") {
      > .conteudo {
        > .albuns {
          justify-content: space-around;
          > .album {
            // > a {
            //   margin: 0 3px 30px 3px;
            // }
          }
        }
      }
    }

    @include media(">=tablet","<desktop") {
      > .conteudo {
        > .albuns {
          justify-content: flex-start;
          > .album {
            > a {
              margin: 0 15px 30px 15px;
            }
          }
        }
      }
    }

    @include media(">=desktop","<hdscreen") {
      > .conteudo {
        > .albuns {
          justify-content: flex-start;
          > .album {
            > a {
              margin: 0 13.5px 30px 13.5px;
            }
          }
        }
      }
    }

    @include media(">=hdscreen") {
      > .conteudo {
        > .albuns {
          justify-content: flex-start;
          > .album {
            > a {
              margin: 0 20px 30px 20px;
            }
          }
        }
      }
    }
  }
</style>

<script>
  import Bloco from 'COMPONENTS/Bloco'
  import Titulo from 'COMPONENTS/ElementTitle'
  import Mensagem from 'COMPONENTS/Mensagem'
  import Paginacao from 'COMPONENTS/Paginacao'
  import Listagem from 'COMPONENTS/GaleriaLista'
  import GaleriaService from '../../js/api/GaleriaService'
  import utils from '../../js/utils'

  export default {
    components: {
      Bloco,
      Titulo,
      Mensagem,
      Paginacao,
      Listagem
    },

    props: {
      reference: { type: String, required: false },
      pagination: { type: Boolean, required: true },
      perPage: { type: Number, required: true }
    },

    data () {
      return {
        albuns: [],
        naoTemGalerias: false,
        totalGalerias: 0,
        totalPages: 0,
        page: 1
      }
    },

    methods: {
      loadGalerias (page = 1, perPage = 8) {
        let galeriasDatas = []
        GaleriaService.getGalerias(page, perPage)
        .then(galeriasDados => {
          galeriasDados.data.forEach(function (galeria) {
            galeriasDatas.push({
              id: galeria.id,
              slug: galeria.slug,
              titulo: galeria.title.rendered,
              imagem: (galeria.acf.fotos[0].acf.link !== '') ? galeria.acf.fotos[0].acf.link : galeria.acf.fotos[0].acf.anexo,
              data: utils.dataWPFormatada(galeria.date)
            })
          })
          this.totalGalerias = parseInt(galeriasDados.headers['x-wp-total'])
          this.totalPages = parseInt(galeriasDados.headers['x-wp-totalpages'])
          if (galeriasDatas.length === 0) {
            this.naoTemGalerias = true
          }
        })
        return galeriasDatas
      }
    },

    watch: {
      page: function () {
        this.albuns = this.loadGalerias(this.page, this.perPage)
      }
    },

    mounted () {
      this.albuns = this.loadGalerias(this.page, this.perPage)
    },

    beforeUpdate () {
      this.page = (this.$route.params.page) ? this.$route.params.page : 1
    }
  }
</script>



// WEBPACK FOOTER //
// Galeria.vue?e6f53cea